export default "__VITE_ASSET__D$XytOYR__"